import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [],totalData:0, error: "", message: '' }

export const charegBackAction = createAsyncThunk(
    'charge-Back',
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({
                page: data?.page || 0,
                limit: data?.limit || 25,
                startDate: data?.startDate || 'undefined',
                endDate: data?.endDate || 'undefined',
                app_id: data?.app_id || 'undefined',
                userId: data?.userId || 'undefined'
            });
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/chargeback/postback/logs?${params.toString()}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const charegBackSlice = createSlice({
    name:'charge-Back',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(charegBackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(charegBackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(charegBackAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const charegBackReducer = charegBackSlice.reducer